import React from 'react'
import { useEffect } from 'react'
import { useState } from 'react'
import { checkValid, setValueForm, updateValidate } from '../../../../../helpers/form/FormHelper'
import { responseError } from '../../../../../helpers/response/ResponseHelper'
import { formDataProductIsField, formDataProductRequiredField } from '../../../../../helpers/form/FormData'
import ErrorMessage from '../../../../UI/messages/ErrorMessage'
import MyButton from '../../../../UI/form/MyButton'
import AgreeSelectMain from '../../../../form/fields/AgreeSelectMain'
import { agreeSupplyBillItemDeputyDirectorSupplyAPI } from '../../../../../api/supply/supplyBillItemAPI'
import { useDispatch } from 'react-redux'
import { editSupplyBillItem, editSupplyBillsItemsAllItem } from '../../../../../store/supplyBillSlice'
import DisagreeTextMain from '../../../../form/fields/DisagreeTextMain'

const AgreeDeputyDirectorSupplyBillItemForm = ({ supplyBillItemBd, setOpen }) => {

    const dispatch = useDispatch()

    const [data, setData] = useState(supplyBillItemBd ? {
        isAgreeDeputyDirectorSupply: supplyBillItemBd.isAgreeDeputyDirectorSupply,
        disagreeDeputyDirectorSupplyText: supplyBillItemBd.disagreeDeputyDirectorSupplyText
    } : {}) // Дані з форми
        
    const [valid, setValid] = useState({}) // Валідація кожного поля
    const [loading, setLoading] = useState(false)

    const [isValidForm, setIsValidForm] = useState(false) // Загальна валідація форми
    const [result, setResult] = useState('')
    const [error, setError] = useState('')

    useEffect(() => {
        checkValid(valid, setIsValidForm)
    }, [valid])

    const save = (e) => {
        e.preventDefault()

        setError('')
        setLoading(true)

        agreeSupplyBillItemDeputyDirectorSupplyAPI({
            id: supplyBillItemBd.id,
            isAgreeDeputyDirectorSupply: data.isAgreeDeputyDirectorSupply,
            disagreeDeputyDirectorSupplyText: data.disagreeDeputyDirectorSupplyText
        }).then(data => {
            if (data) {
                dispatch(editSupplyBillItem(data))
                dispatch(editSupplyBillsItemsAllItem(data))
                // dispatch(editSupplyBillItemIsAgreeSupplyLeader({
                //     id: data.id,
                //     isAgreeDeputyDirectorSupply: data.isAgreeDeputyDirectorSupply
                // }))
                // dispatch(setSupplyBillsItemsAllIsAgreeSupplyLeader({ // В окремому списку всіх позицій
                //     id: data.id,
                //     isAgreeDeputyDirectorSupply: data.isAgreeDeputyDirectorSupply
                // }))
            }

            setOpen(false)
            setLoading(false)
        }).catch(e => {
            setError(responseError(e))
            setLoading(false)
        })
    }

  return (
    <div className='myFormSimple'>
        <div>
            <p>
                Погодження позиції в рахунку заступником директора постачання
            </p>
        </div>
        {
			formDataProductIsField('agree', 'supplyBillItemAgree') ?
				<AgreeSelectMain
					required={formDataProductRequiredField('agree', 'supplyBillItemAgree')}
					setValidate={e => updateValidate(setValid, 'isAgreeDeputyDirectorSupply', e)}
					setValueForm={e => setValueForm(setData, 'isAgreeDeputyDirectorSupply', e)}
					forciblyValue={
                        data && data.isAgreeDeputyDirectorSupply === true ? true :
                        data && data.isAgreeDeputyDirectorSupply === false ? false : ''
                    }
				/>
			: ''
        }
        {
			formDataProductIsField('disagreeText', 'supplyBillItemAgree') ?
				<DisagreeTextMain
					// required={formDataProductRequiredField('disagreeText', 'supplierAgree')}
					required={
                        data && (data.isAgreeDeputyDirectorSupply === false || data.isAgreeDeputyDirectorSupply === 'no') ? true  :
                        formDataProductRequiredField('disagreeText', 'supplyBillItemAgree')
                    }
					setValidate={e => updateValidate(setValid, 'disagreeDeputyDirectorSupplyText', e)}
					setValueForm={e => setValueForm(setData, 'disagreeDeputyDirectorSupplyText', e)}
					forciblyValue={data ? data.disagreeDeputyDirectorSupplyText : ''}
                    className={data && (data.isAgreeDeputyDirectorSupply === false || data.isAgreeDeputyDirectorSupply === 'no') ? '' : 'hide'}
				/>
			: ''
        }

        <ErrorMessage
            error={error}
        />

        <MyButton
            size='md'
            onClick={save}
            disabled={!isValidForm || loading ? true : false}
        >
            Зберегти
        </MyButton>
    </div>
  )
}

export default AgreeDeputyDirectorSupplyBillItemForm